import {
    Component,
    OnInit,
    Input,
  } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetApprovalDataStartAction } from '../_store/resources.actions';
import { tap } from 'rxjs/operators';
  @Component({
    selector: 'approvals',
    templateUrl: './approvals.component.html',
    styleUrls: ['./approvals.component.scss']
  })
  export class ApprovalsComponent implements OnInit {
    approval$;
    constructor(private store : Store<AppState>) {  }
  
    ngOnInit() {
        this.store.dispatch(new GetApprovalDataStartAction());
        this.approval$ = this.store.select(state => state.resources.approvalData).pipe(
            tap(data => {
                console.log(data, 'approval data' );
            })
          )
    }
  }